import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useEmpresaAuth } from '../../../contexts/EmpresaAuthContext';
import Layout from '../../../components/shared/Layout/Layout';
import Button from '../../../components/shared/Button/Button';
import {
  AuthContainer,
  AuthCard,
  AuthTitle,
  AuthSubtitle,
  AuthFooter,
  FormGroup,
  FormLabel,
  FormInput,
  ErrorMessage,
} from '../../../components/shared/Form/Form.styles';
import { CompanyFeatures } from './Login.styles';
import { peekSessionNotice, clearSessionNotice } from '../../../utils/sessionExpiry';

const EmpresaLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(() => peekSessionNotice('empresa'));
  const [loading, setLoading] = useState(false);

  const { login } = useEmpresaAuth();
  const navigate = useNavigate();

  useEffect(() => { clearSessionNotice('empresa'); }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      navigate('/empresa/dashboard');
    } else {
      setError(result.error || 'Error al iniciar sesión');
    }
    setLoading(false);
  };

  return (
    <Layout headerType="empresa">
      <AuthContainer>
        <AuthCard>
          <AuthTitle>Portal empresarial</AuthTitle>
          <AuthSubtitle>Gestiona tu negocio turístico en BokerHub</AuthSubtitle>

          <CompanyFeatures>
            <ul>
              <li>Publica actividades y atracciones</li>
              <li>Valida reservas con códigos QR</li>
              <li>Recibe pagos protegidos por Stripe</li>
            </ul>
          </CompanyFeatures>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <form onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel>Email empresarial</FormLabel>
              <FormInput
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="empresa@ejemplo.com"
                required
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Contraseña</FormLabel>
              <FormInput
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Tu contraseña"
                required
              />
            </FormGroup>

            <Button type="submit" fullWidth disabled={loading}>
              {loading ? 'Iniciando sesión...' : 'Ingresar al portal'}
            </Button>
          </form>

          <AuthFooter>
            <p>¿No tienes cuenta empresarial? <Link to="/empresa/register">Registra tu empresa</Link></p>
            <hr />
            <p>¿Formas parte del equipo de una empresa? <Link to="/staff/login">Acceso del equipo</Link></p>
            <p>¿Eres viajero? <Link to="/login">Inicia sesión aquí</Link></p>
          </AuthFooter>
        </AuthCard>
      </AuthContainer>
    </Layout>
  );
};

export default EmpresaLogin;
